import { useState, useEffect } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Reads the current user's role from the Cognito ID token payload (custom:role claim).
 */
export const useUserRole = () => {
  const [role, setRole] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    fetchAuthSession()
      .then((session) => {
        const payload = session.tokens?.idToken?.payload;
        const userRole = (payload?.['custom:role'] as string) ?? null;
        if (mounted) {
          setRole(userRole);
          setIsLoading(false);
        }
      })
      .catch(() => {
        if (mounted) {
          setRole(null);
          setIsLoading(false);
        }
      });
    return () => {
      mounted = false;
    };
  }, []);

  return {
    role,
    isLoading,
    isTechnician: role === 'TECHNICIAN',
    isClient: role === 'CLIENT',
  };
};
